import { isEmpty, forEach } from 'lodash';
import { onCLS, onFCP, onFID, onINP, onLCP, onTTFB } from 'web-vitals';

import DataDogLogs from 'utils/DataDogLogs';
import Log from 'utils/Log';

/* 
  Telemetry Logger
  This service reads Telemetry logs in the local storage queue, sends to Datadog, and then cleans them from the queue
*/

export const STATUSES = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};

const STORAGE_KEY = 'ab_pendingTelemetry';

const TelemetryLog = class {
  static init() {
    window.addEventListener('abTelemetryLogPending', event => {
      try {
        const dispatchSource = event.detail;
        TelemetryLog.logPending(dispatchSource);
      } catch (error) {
        Log.error('TelemetryLog:abTelemetryLogPending failed');
      }
    });

    window.addEventListener('abTelemetryLog', event => {
      try {
        const item = event.detail;
        if (item) {
          TelemetryLog.removePendingTelemetryItem(item);
          TelemetryLog.logTelemetryItem(item);
        }
      } catch (error) {
        Log.error('TelemetryLog:abTelemetryLog failed');
      }
    });

    onCLS(TelemetryLog.sendToAnalytics);
    onFCP(TelemetryLog.sendToAnalytics);
    onFID(TelemetryLog.sendToAnalytics);
    onINP(TelemetryLog.sendToAnalytics);
    onLCP(TelemetryLog.sendToAnalytics);
    onTTFB(TelemetryLog.sendToAnalytics);
  }

  static sendToAnalytics({ name, value }) {
    const formattedValue = Number(value.toFixed(2));

    const message = `type=pageLoadTelemetry | resourceName="Web Vitals" | ${name}=${formattedValue}`;
    TelemetryLog.logInfo(message, {
      [name]: formattedValue,
    });
  }

  static logInfo(message, data) {
    if (!message || !data) return;

    DataDogLogs.info(message, {
      browserTelemetry: data,
    });
  }

  static logTelemetryItem(item) {
    const { resourceName, status } = item;
    const message = `type=pageLoadTelemetry | resourceName="${resourceName}" | resourceLoadStatus=${
      status === STATUSES.SUCCESS ? STATUSES.SUCCESS : STATUSES.FAILURE
    }`;
    const itemWithMessage = { ...item, content: { message } };
    TelemetryLog.logInfo(message, itemWithMessage);
    Log.debug(message, itemWithMessage);
  }

  static removePendingTelemetryItem(item) {
    try {
      const pendingTelemetry = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (!pendingTelemetry) return;

      delete pendingTelemetry[item.resourceName];
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(pendingTelemetry));
    } catch (error) {
      Log.error('TelemetryLog:removePendingTelemetryItem failed');
    }
  }

  static logPending(dispatchSource) {
    try {
      const pendingTelemetry = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (!pendingTelemetry || isEmpty(pendingTelemetry)) return;

      forEach(pendingTelemetry, item => {
        if (typeof item === 'object') {
          TelemetryLog.logTelemetryItem({ ...item, dispatchSource });
        }
      });

      // Reset pending telemetry object to empty
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({}));
    } catch (error) {
      Log.error('TelemetryLog:logPending failed');
    }
  }
};

export default TelemetryLog;
